/**
 * VistaGare Web Push (paid Radar) — subscribe via gateway + /api/sw.js
 */
(function (win) {
    'use strict';

    function rootEl() {
        return document.documentElement || document.body;
    }

    function apiBase() {
        var base = (rootEl() && rootEl().getAttribute('data-api-base')) || '/api/';
        return String(base).replace(/\/+$/, '');
    }

    function api(path) {
        return apiBase() + path;
    }

    function swUrl() {
        return api('/sw.js');
    }

    function urlBase64ToUint8Array(base64String) {
        var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        var rawData = win.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    function supported() {
        if (!win.isSecureContext) return false;
        return !!(
            win.navigator &&
            win.navigator.serviceWorker &&
            win.PushManager &&
            win.Notification
        );
    }

    function unsupportedReason() {
        if (!win.isSecureContext) return 'https';
        if (!supported()) return 'api';
        return '';
    }

    function permissionState() {
        if (!win.Notification) return 'unsupported';
        return win.Notification.permission || 'default';
    }

    function registerSw() {
        if (!supported()) return Promise.reject(new Error('unsupported'));
        return win.navigator.serviceWorker.register(swUrl(), { scope: '/' });
    }

    function readyRegistration() {
        return registerSw().then(function () {
            return win.navigator.serviceWorker.ready;
        });
    }

    function fetchVapidKey() {
        return fetch(api('/web-push/vapid-public-key'), { headers: { Accept: 'application/json' } })
            .then(function (r) {
                if (!r.ok) throw new Error('vapid');
                return r.json();
            })
            .then(function (d) {
                var key = d && d.public_key;
                if (!key) throw new Error('vapid');
                return key;
            });
    }

    function postSubscribe(memberUuid, sub) {
        var json = sub.toJSON();
        return fetch(api('/web-push/subscribe'), {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({
                member_uuid: memberUuid,
                endpoint: json.endpoint,
                keys: json.keys,
                user_agent: (win.navigator && win.navigator.userAgent) || ''
            })
        }).then(function (r) {
            if (!r.ok) throw new Error('subscribe ' + r.status);
            return r.json();
        });
    }

    function postUnsubscribe(memberUuid, endpoint) {
        return fetch(api('/web-push/unsubscribe'), {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ member_uuid: memberUuid, endpoint: endpoint })
        });
    }

    function postSettings(memberUuid, enabled) {
        return fetch(api('/web-push/settings'), {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ member_uuid: memberUuid, enabled: !!enabled })
        }).then(function (r) {
            if (!r.ok) throw new Error('settings ' + r.status);
            return r.json();
        });
    }

    function getSettings(memberUuid) {
        return fetch(api('/web-push/settings?member=' + encodeURIComponent(memberUuid)), {
            headers: { Accept: 'application/json' }
        }).then(function (r) {
            if (!r.ok) throw new Error('settings');
            return r.json();
        });
    }

    function subscribeMember(memberUuid) {
        if (!memberUuid) return Promise.reject(new Error('member'));
        return readyRegistration()
            .then(function (reg) {
                return fetchVapidKey().then(function (vapidKey) {
                    return reg.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(vapidKey)
                    });
                });
            })
            .then(function (sub) {
                return postSubscribe(memberUuid, sub).then(function () {
                    return sub;
                });
            });
    }

    function enable(memberUuid) {
        if (!supported()) return Promise.reject(new Error('unsupported'));
        if (permissionState() === 'denied') return Promise.reject(new Error('denied'));
        return win.Notification.requestPermission().then(function (perm) {
            if (perm !== 'granted') throw new Error('denied');
            return subscribeMember(memberUuid).then(function () {
                return postSettings(memberUuid, true);
            });
        });
    }

    function disable(memberUuid) {
        return readyRegistration()
            .then(function (reg) {
                return reg.pushManager.getSubscription();
            })
            .then(function (sub) {
                var chain = postSettings(memberUuid, false);
                if (!sub) return chain;
                var endpoint = sub.endpoint;
                return sub
                    .unsubscribe()
                    .catch(function () {})
                    .then(function () {
                        return postUnsubscribe(memberUuid, endpoint);
                    })
                    .then(function () {
                        return chain;
                    });
            });
    }

    function syncIfEnabled(memberUuid) {
        if (!memberUuid || !supported()) return Promise.resolve();
        return getSettings(memberUuid)
            .then(function (data) {
                if (!data || !data.enabled || !data.vapid_configured) return null;
                if (permissionState() !== 'granted') return null;
                return readyRegistration().then(function (reg) {
                    return reg.pushManager.getSubscription();
                });
            })
            .then(function (sub) {
                if (!sub || !memberUuid) return;
                return postSubscribe(memberUuid, sub);
            })
            .catch(function () {});
    }

    win.VistaGareWebPush = {
        supported: supported,
        unsupportedReason: unsupportedReason,
        permissionState: permissionState,
        registerSw: registerSw,
        getSettings: getSettings,
        enable: enable,
        disable: disable,
        syncIfEnabled: syncIfEnabled
    };

    function initSettingsPanel() {
        var wrap = document.querySelector('[data-web-push-settings]');
        if (!wrap) return;
        var member = wrap.getAttribute('data-member-uuid') || '';
        if (!member) return;
        var chk = wrap.querySelector('[data-web-push-enabled]');
        var unsupportedEl = wrap.querySelector('[data-web-push-unsupported]');
        var deniedEl = wrap.querySelector('[data-web-push-denied]');
        var statusEl = wrap.querySelector('[data-web-push-status]');
        var busy = false;

        function setStatus(msg) {
            if (statusEl) statusEl.textContent = msg || '';
        }

        function refreshUi(data) {
            data = data || {};
            if (!supported()) {
                if (unsupportedEl) {
                    unsupportedEl.hidden = false;
                    var reason = unsupportedReason();
                    if (reason === 'https') {
                        unsupportedEl.textContent =
                            'Le notifiche push richiedono una connessione sicura (HTTPS).';
                    }
                }
                if (chk) {
                    chk.disabled = true;
                    chk.checked = false;
                }
                return;
            }
            if (unsupportedEl) unsupportedEl.hidden = true;
            var perm = permissionState();
            if (deniedEl) deniedEl.hidden = perm !== 'denied';
            if (chk) chk.checked = data.enabled === true;
            var n = data.subscription_count || 0;
            if (data.enabled && n > 0) {
                setStatus(n === 1 ? 'Attivo su 1 dispositivo.' : 'Attivo su ' + n + ' dispositivi.');
            } else if (data.enabled) {
                setStatus('Abilitato: completa il permesso del browser se richiesto.');
            } else {
                setStatus('');
            }
            if (!data.vapid_configured) {
                setStatus('Notifiche browser temporaneamente non disponibili.');
                if (chk) chk.disabled = true;
            } else if (chk) {
                chk.disabled = false;
            }
        }

        function load() {
            if (!supported()) {
                refreshUi({});
                return;
            }
            getSettings(member)
                .then(refreshUi)
                .catch(function () {
                    setStatus('Impossibile caricare le impostazioni browser.');
                });
        }

        if (chk) {
            chk.addEventListener('change', function () {
                if (busy) return;
                busy = true;
                chk.disabled = true;
                var on = !!chk.checked;
                var action = on ? enable(member) : disable(member);
                action
                    .then(function () {
                        return getSettings(member);
                    })
                    .then(refreshUi)
                    .catch(function (err) {
                        if (chk) chk.checked = !on;
                        if (err && String(err.message || err) === 'denied' && deniedEl) {
                            deniedEl.hidden = false;
                        }
                        setStatus(on ? 'Attivazione non riuscita.' : 'Disattivazione non riuscita.');
                    })
                    .then(function () {
                        busy = false;
                        if (chk && supported()) chk.disabled = false;
                    });
            });
        }

        load();
    }

    function onReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    onReady(initSettingsPanel);
})(window);
